module.exports = __webpack_public_path__ + "img/coco-club-06.41a0f1ec.jpg";